import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { LoadingSpinner } from '../common'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRole?: 'ADMIN' | 'BUSINESS' | 'PACKER'
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const location = useLocation()
  const { isAuthenticated, user, loading } = useSelector((state: RootState) => state.auth)

  // 如果正在加载，显示加载状态
  if (loading) {
    return <LoadingSpinner />
  }

  // 如果未认证，重定向到登录页
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // 如果需要特定角色权限，检查用户角色
  if (requiredRole) {
    const hasPermission = checkRolePermission(user.role, requiredRole)
    if (!hasPermission) {
      return (
        <div className="flex-center" style={{ minHeight: '400px' }}>
          <div style={{ textAlign: 'center' }}>
            <h3>权限不足</h3>
            <p>您没有访问此页面的权限</p>
          </div>
        </div>
      )
    }
  }

  return <>{children}</>
}

// 角色权限检查函数
const checkRolePermission = (userRole: string, requiredRole: string): boolean => {
  // 管理员拥有所有权限
  if (userRole === 'ADMIN') {
    return true
  }

  // 业务员可以访问业务相关功能
  if (userRole === 'BUSINESS' && (requiredRole === 'BUSINESS' || requiredRole === 'PACKER')) {
    return true
  }

  // 装箱员只能访问装箱功能
  if (userRole === 'PACKER' && requiredRole === 'PACKER') {
    return true
  }

  return userRole === requiredRole
}

export default ProtectedRoute